import { Route, NavigationGuard } from 'vue-router';
import TokenService from '../services/TokenService';

type Next = Parameters<NavigationGuard>[2];

export const ifNotAuthenticated = (to: Route, from: Route, next: Next): void => {
  if (!TokenService.isTokenValid()) {
    next();
    return;
  }
  next('/app');
};

export const ifAuthenticated = (to: Route, from: Route, next: Next): void => {
  if (to.name === 'PostAuth') {
    next();
    return;
  }

  if (TokenService.isTokenValid()) {
    next();
    return;
  }

  next('/login');
};
